import { connect } from 'react-redux';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { LoggedInUserLinks } from './LoggedInUserLinks';
import { watchUserLinksSaga, logoutUser } from './LoggedInUserLinks.saga';

export const mapDispatchToProps = {
  onClickLogout: logoutUser,
};

export const LoggedInUserLinksContainer = decorateWith(
  connect(
    null,
    mapDispatchToProps
  ),
  withSagas({
    watch: watchUserLinksSaga,
  }),
  withName('LoggedInUserLinks')
)(LoggedInUserLinks);
